<template>
  <div class="overflow-hidden rounded-xl border bg-card shadow-sm">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead v-if="showCompany" class="min-w-48">
            Company
          </TableHead>
          <TableHead class="min-w-48">
            Holiday
          </TableHead>
          <TableHead class="min-w-40">
            Date
          </TableHead>
          <TableHead class="min-w-44">
            Schedule
          </TableHead>
          <TableHead>Status</TableHead>
          <TableHead class="min-w-64 text-right">
            Actions
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow v-for="holiday in holidays" :key="holiday[rowIdKey]">
          <TableCell v-if="showCompany" class="font-medium">
            {{ holiday.company?.name }}
          </TableCell>
          <TableCell class="font-medium">
            {{ holiday.name }}
          </TableCell>
          <TableCell class="text-muted-foreground">
            {{ formatDate(holiday.date) }}
          </TableCell>
          <TableCell>
            <div class="flex flex-col gap-1">
              <span>{{ scheduleSummary(holiday) }}</span>
              <span v-if="holiday.notes" class="max-w-64 truncate text-xs text-muted-foreground">{{ holiday.notes }}</span>
              <span v-else-if="!holiday.confirmed" class="text-xs text-muted-foreground">Default schedule</span>
            </div>
          </TableCell>
          <TableCell>
            <Badge v-if="holiday.locked" variant="outline" class="gap-1 bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200">
              <LockKeyhole class="h-3.5 w-3.5" />
              Locked
            </Badge>
            <Badge v-else-if="holiday.confirmed" variant="outline" class="gap-1 border-emerald-200 bg-emerald-100 text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-200">
              <CircleCheck class="h-3.5 w-3.5" />
              Confirmed
            </Badge>
            <Badge v-else variant="outline" class="border-amber-200 bg-amber-100 text-amber-800 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200">
              Needs confirmation
            </Badge>
          </TableCell>
          <TableCell class="text-right">
            <div v-if="!holiday.locked || allowLockedEditing" class="flex justify-end gap-2">
              <Button v-if="!holiday.confirmed" type="button" size="sm" :loading="savingIds.includes(holiday[rowIdKey])" @click="emit('confirm-defaults', holiday)">
                <Check class="h-4 w-4" />
                Confirm defaults
              </Button>
              <Button type="button" variant="outline" size="sm" :disabled="savingIds.includes(holiday[rowIdKey])" @click="emit('edit', holiday)">
                <Pencil class="h-4 w-4" />
                Edit
              </Button>
            </div>
            <span v-else class="text-sm text-muted-foreground">Contact Centratel to change</span>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </div>
</template>

<script setup>
import { Check, CircleCheck, LockKeyhole, Pencil } from 'lucide-vue-next'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { formatDate, scheduleSummary } from '../holidaySchedulePresentation.js'

defineProps({
  holidays: { type: Array, required: true },
  savingIds: { type: Array, default: () => [] },
  showCompany: { type: Boolean, default: false },
  allowLockedEditing: { type: Boolean, default: false },
  rowIdKey: { type: String, default: 'holiday_id' },
})

const emit = defineEmits(['confirm-defaults', 'edit'])
</script>
